import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import ExclusiveStarIcon from '../common/ExclusiveStarIcon';

type Props = {
    title: string;
    icon: React.ReactNode;
    route: string;
    onClick: () => void;
    isPremiumFeature?: boolean;
}

const MobileHeaderRow = (props: Props) => {
    let location = useLocation()
    const { t, i18n } = useTranslation();
    const styledIcon = React.cloneElement(props.icon as any, {
        className: "flex justify-center items-center w-full h-full", // or any additional props you want to pass
        style: { fontSize: "34px" }
    });
    const [isSelected, setIsSelected] = React.useState(false);

    useEffect(() => {
        const isMatching = matchPath(props.route, location.pathname);
        setIsSelected(isMatching != null ? true : false);
    }, [location]);

    function getLinkColor() {
        if (isSelected) {
            return 'bg-utility-mutedLight text-primary-dark'
        }
        return 'bg-primary hover:bg-primary-light text-white'
    }

    return (
        <Link to={props.route.replace(":lang", i18n.language)} onClick={props.onClick} className={`relative flex gap-1 bg-primary rounded-[8px] py-[8px] px-[4px] ${getLinkColor()}`}>
            <div className="px-2">
                {styledIcon}
            </div>
            <div className="font-bold text-[18px] flex  items-center w-full h-full">
                {t(props.title)}
            </div>
            {props.isPremiumFeature && (
                <ExclusiveStarIcon className={"absolute -top-3 -right-3 text-white"} />
            )}
        </Link>
    )
}

export default MobileHeaderRow